<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Producto
            <router-link :to="{ name: 'Productos' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  label="Nombre del producto:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9">
                <label>Pertenece a:</label>
                <v-select
                  v-model="pertenece_id"
                  :options="productos"
                  class="margin-multi"
                  placeholder="Selecciona una producto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.unidad.$model"
                  :isValid="checkIfValid('unidad')"
                  label="Unidad:"
                  placeholder="Unidad..."
                  invalidFeedback=" El campo debe tener como maximo 10 caracteres"
                />
              </CCol>
            </CRow>

            <CRow v-if="pertenece_id_value">
              <CCol sm="9">
                <label>Tipo de costo:</label>
                <v-select
                  :options="tiposCosto"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un tipo de costo"
                  v-model="tipo_costo"
                  :class="checkIfValid('tipo_costo')===false?'is-invalid':''"
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                >
                  <template #footer v-if="checkIfValid('tipo_costo')===false">
                    <div class="invalid-feedback">Campo requerido</div>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>

            <ExtraConfigInput
              title="del producto"
              parametro="productos_atributos_extras"
              v-model="fieldsExtra"
              @config="config => (fieldsExtraConfig = config)"
              @onValid="v => (valid = v)"
            />

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Productos' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">
                Cancelar
              </CButton>
            </router-link>

            <CButton
              @click="addProducto()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Producto"
      :centered="true"
      color="warning"
      :show.sync="warningModal">
        {{ error }}
      </CModal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from "./../../customComponents/ExtraConfigInput.vue";

export default {
  name: "EditarProducto",

  components: {
    vSelect,
    ExtraConfigInput
  },

  data() {
    return {
      valid: {flag: true},
      fieldsExtraConfig: [],
      fieldsExtra: {},
      id: this.$route.params.id,
      item: {},
      pertenece_id: null,
      nombre: "",
      tipo_costo: null,
      unidad: "",
      productos: [],
      tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
      warningModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      fetching: false,
      medias: []
    };
  },

  mixins: [validationMixin],
  validations: {
    nombre: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    unidad: {
      maxLength: maxLength(10)
    },
    tipo_costo: {
      required: (v,data)=>{
        return data.pertenece_id?.value?(v?.value||false):true
      },
    }
  },

  computed: {
    pertenece_id_value(){
      return this.pertenece_id?.value?true:false
    },
    isValidProducto() {
      return !this.$v.nombre.$invalid;
    },
    isValidUnidad() {
      return !this.$v.unidad.$invalid;
    },
    isValidTipoCosto() {
      return !this.$v?.tipo_costo.$invalid;
    }
  },

  created() {
    this.isLoadingPage = true;
    const prod = [
      this.$store.dispatch("customHTTP", {
        schema: "productos",
        filter: {
          where: [
            {
              field: "payload->unidad",
              value: "",
              operator: "="
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "productos",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    Promise.all(prod)
      .then(([productos, item]) => {
        this.productos = productos.data.map(producto => {
          return { value: producto.id, label: producto.payload.nombre };
        });
        this.item = item.data[0];
        this.nombre = this.item.payload.nombre;
        this.tipo_costo = this.tiposCosto.find(f=>f.value == this.item.payload.tipo_costo);
        this.pertenece_id = this.productos.find(
          prod => prod.value == this.item.payload.pertenece_id
        );
        this.unidad = this.item.payload.unidad;
        this.medias = this.item.payload.anexos;

        if (this.item.payload.extras !== undefined) {
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1];
          }
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async m => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    async addProducto() {
      this.validateProducto();
      this.isLoading = true;
      this.fetching = true;
      await new Promise(res => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            clearInterval(iter);
            res();
          }
          debugger;
        }, 1000);
      });
      this.isLoading = false;
      // clean numbers extra fileds
      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
      }
      if(this.error){
        return
      }

      this.fieldsExtraConfig.forEach(indexField => {
        if (indexField.tipo === "number") {
          this.fieldsExtra[indexField.nombre] =
            Number(this.fieldsExtra[indexField.nombre]) || 0;
        }
        if (indexField.tipo === "text") {
          this.fieldsExtra[indexField.nombre] =
            this.fieldsExtra[indexField.nombre] || "";
        }
      });

      if (this.isValidProducto && this.isValidUnidad && this.isValidTipoCosto) {
        this.isLoading = true;
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "productos",
            id: this.id,
            payload: {
              nombre: this.nombre,
              tipo_costo: this.tipo_costo ? this.tipo_costo.value : '',
              pertenece_id: this.pertenece_id ? this.pertenece_id.value : 0,
              unidad: this.unidad,
              anexos: this.medias,
              extras: this.fieldsExtra,
            }
          })
          .then(() => {
            // console.log(res.data);
            this.$router.push({ name: "Productos" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field?.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateProducto() {
      this.error = ''
      this.$v.$touch();
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
